var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('b-checkbox',{on:{"input":_vm.updateTask},model:{value:(_vm.completed),callback:function ($$v) {_vm.completed=$$v},expression:"completed"}},[_vm._v(" "+_vm._s(_vm.taskName)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }